import React from 'react';
import Head from 'next/head';

export const FONTS = {
  'Source Sans Pro': 'Source Sans 3',
  'Droid Serif': 'Noto Serif',
  Lato: 'Lato',
  Montserrat: 'Montserrat',
  'Open Sans': 'Open Sans',
  Raleway: 'Raleway',
};

interface FontProviderProps {
  font: string;
}

const FontProvider = ({ font }: FontProviderProps) => {
  let fontFamily = FONTS['Source Sans Pro'];
  if (Object.keys(FONTS).includes(font)) {
    fontFamily = FONTS[font];
  }

  return (
    <Head>
      <link href="https://fonts.googleapis.com" rel="preconnect" />
      <link href="https://fonts.gstatic.com" rel="preconnect" />
      <link
        href={`https://fonts.googleapis.com/css?family=${encodeURI(
          fontFamily
        )}:300,400,600,700`}
        rel="stylesheet"
      />
      <style>
        {`body, input, button, textarea, .emoji-mart { font-family: "${fontFamily}"; }`}
      </style>
    </Head>
  );
};

export default FontProvider;
